<div class="content-body">
  <div class="question">Q: What is a Site Note?</div>
  <div class="description">
     A Site Note is a feature that allows you to record information about a specific site. <br/><br/>You can note installation details, account-related information, service discussions, sales-related content, and other important information that needs to be shared and documented. <br/><br/>
    <ul> 
      <li>Up to 10 notes per site can be registered</li>
    </ul>
  </div>
</div>